import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.FACTOR;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.Factor,
  },
  validateSearch: zodValidator(withDefaults(schema.FACTOR, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
